import { render, staticRenderFns } from "./index.vue?vue&type=template&id=03c072cc&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=03c072cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c072cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2026/QianKunLong/QklAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03c072cc')) {
      api.createRecord('03c072cc', component.options)
    } else {
      api.reload('03c072cc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=03c072cc&scoped=true&", function () {
      api.rerender('03c072cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/config/systemConfig/index.vue"
export default component.exports